import { branchBasedFeedbackDataFilter } from "./multipleBranch/getActiveBranchId";

export function genPieChartData(bId) {
  const data = JSON.parse(sessionStorage.getItem("subData"));
  const qdata = JSON.parse(localStorage.getItem("questions"));

  if (data == null || qdata == null) return null;

  const data1 = branchBasedFeedbackDataFilter(data, bId);
  return pieDataGenerator2(data1, qdata);
}

function pieDataGenerator2(data, qdata) {
  // till here data is simple feedback data.

  let chartArray = [];

  /**
   *  phase 1 - formation of chartArray that will contain blank info for Pie Chart  
    phase 2  we fill this chart object with actual frequency data.  
   */

  //Example of how we are populating chartArray.
  /**
   *   [
     {
    questionTitle: "How was the Food",
    
    options  : [ 
      {optionTitle: 'Excellent', count: 6},
      {optionTitle: 'Good', count: 5},
      {optionTitle: 'ok-ok', count: 4}
    
    ]
  }
  ] NEXT PHASE HOW I Want to populate.
   [{
    quesitonTitle:"How was teh Food";
    
   }]
   */

  // phase 1 iterating over question data to create structure of chartArray Array.

  qdata?.optionQuestions?.forEach((item, index) => {
    let chartQuestion = {
      questionTitle: "",
      options: [],
    };

    chartQuestion.questionTitle = item.title;
    item.options.forEach((element) => {
      let optObj = {};
      optObj.optionTitle = element;
      optObj.count = 0;
      chartQuestion.options.push(optObj);
    });

    chartArray.push(chartQuestion);
  });

  // PHASE 2 now iterating over feedback data to fill count in chartArray Array.

  /*  
       here data.data.optionQuestion is the answer object that container feedback answer
    and charObject was created from feedback questions
     */
  data?.forEach((data) => {
    data.data?.optionQuestions.forEach((item) => {
      chartArray.forEach((ele) => {
        if (item.title == ele.questionTitle) {
          ele.options.forEach((i) => {
            //  console.log(i);
            if (i.optionTitle == item.answer) {
              i.count += 1;
            }
          });
        }
      });
    });
  });

  return chartArray;
}

export function pieChartPercentageCalculator(data) {
  /*
  format of data - {quesitonTitle, options:[{optionTitle, count},{}]}
  */
  // console.log(data);
  if (data == null) return null;
  let totalCount = 0;
  data.options.forEach((item) => {
    totalCount += item.count;
  });
  // console.log(totalCount);
  const output = [];
  data.options.forEach((item, index) => {
    let obj = { optionTitle: "", percentage: " %" };
    obj.optionTitle = item.optionTitle;

    let p = 0;
    if (item.count != 0) {
      p = (item.count * 100) / totalCount;
      p = Math.round(p * 100) / 100;
    }

    obj.percentage = p;
    output.push(obj);
  });

  return output;
}
